<template>
    <div class="chart-container">
      <canvas id="barChart"></canvas>
    </div>
  </template>
  
  <script>
  export default {
    name: "BarChart",
    props: {
      months: {
        type: Array,
        required: true, // Example: ["January", "February", "March"]
      },
      values: {
        type: Array,
        required: true, // Example: [120, 150, 180]
      },
    },
    mounted() {
      this.renderBarChart();
    },
    methods: {
      renderBarChart() {
        const ctx = document.getElementById("barChart").getContext("2d");
        new window.Chart(ctx, {
          type: "bar",
          data: {
            labels: this.months, // Months on the X-axis
            datasets: [
              {
                label: "Monthly Data",
                data: this.values, // Corresponding values for each month
                backgroundColor: "rgba(75, 192, 192, 0.6)",
                borderColor: "rgba(75, 192, 192, 1)",
                borderWidth: 1,
              },
            ],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              y: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: "Values",
                },
              },
              x: {
                title: {
                  display: true,
                  text: "Months",
                },
                ticks: {
                  autoSkip: false, // Ensure all labels are displayed
                  maxRotation: 45, // Maximum rotation of 45 degrees
                  minRotation: 30, // Minimum rotation of 30 degrees
                },
              },
            },
          },
        });
      },
    },
  };
  </script>
  
  <style scoped>
  .chart-container {
    width: 90vw; /* Adjust container width */
    height: 100vh; /* Full viewport height */
  }
  
  canvas {
    width: 100%; /* Let the canvas take full width of the container */
    height: 100%; /* Let the canvas take full height of the container */
  }
  </style>
  